import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
    NgbDateAdapter,
    NgbDateParserFormatter,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbCollapseModule,
} from '@ng-bootstrap/ng-bootstrap';

import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { NgApexchartsModule } from 'ng-apexcharts';

import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ComponentsModule } from '@ed---interne/ng-uui-components';

import { EdDatepickerComponent } from './components/forms/ed-datepicker/ed-datepicker.component';
import {
    CustomAdapter,
    CustomDateParserFormatter,
} from './components/forms/ed-datepicker/ngbd-datepicker.adapter';
import { EdInputFileComponent } from './components/forms/ed-input-file/ed-input-file.component';
import { DropZoneDirective } from './components/forms/ed-input-file/dropzone.directive';
import { InfiniteScrollDirective } from './directives/infinite-scroll.directive';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { ChartCardComponent } from './components/chart-card/chart-card.component';
import { KpiCardComponent } from './components/kpi-card/kpi-card.component';
import { GeoMapCardComponent } from './components/geo-map-card/geo-map-card.component';
import { GenericCardComponent } from './components/generic-card/generic-card.component';
import { MapComponent } from './components/map/map.component';
import { TableCardComponent } from './components/table-card/table-card.component';
import { EdTableModule } from './components/ed-table/ed-table.module';
import { SkeletonListComponent } from './components/skeleton-list/skeleton-list.component';
import { EdSwitchComponent } from './components/forms/ed-switch/ed-switch.component';

@NgModule({
    declarations: [
        EdDatepickerComponent,
        EdInputFileComponent,
        GenericCardComponent,
        KpiCardComponent,
        GeoMapCardComponent,
        MapComponent,
        ChartCardComponent,
        DropZoneDirective,
        TableCardComponent,
        EdSwitchComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgbDatepickerModule,
        NgbDropdownModule,
        NgbCollapseModule,
        ComponentsModule,
        InfiniteScrollDirective,
        DragAndDropDirective,
        MatSelectModule,
        MatSlideToggleModule,
        NgxTippyModule,
        NgApexchartsModule,
        MatMenuModule,
        EdTableModule,
        SkeletonListComponent,
    ],
    exports: [
        EdDatepickerComponent,
        EdInputFileComponent,
        GenericCardComponent,
        KpiCardComponent,
        GeoMapCardComponent,
        ChartCardComponent,
        MapComponent,
        DropZoneDirective,
        InfiniteScrollDirective,
        DragAndDropDirective,
        TableCardComponent,
        SkeletonListComponent,
        EdSwitchComponent,
    ],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
        DatePipe,
    ],
})
export class SharedModule {}
